import React from 'react';
import { TransformCta } from '../TransformCta';
export function Problem() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-258" data-mp="2wfdj7ab48sze">
      <div className="mx-auto max-w-2xl" data-id="element-259" data-mp="2wh844ome0l3h">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-gold-600" data-id="element-260" data-mp="2rnvdya22868m">
          Más que aprender a analizar rostros…
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-261" data-mp="2mn7pnw57u3i3">
          Aprenderás a tomar mejores decisiones clínicas
        </h2>

        <div className="mt-6 space-y-3.5 text-[15px] leading-relaxed text-navy-600 sm:text-[17px]" data-id="element-262" data-mp="2cth5h3g4gf87">
          <p data-id="element-263" data-mp="28rdra722iwj8">Porque un tratamiento exitoso no comienza cuando colocas el primer bracket.</p>
          <p className="font-semibold text-navy-900" data-id="element-264" data-mp="23sj12k1ru5p3">
            Comienza en el momento en que interpretas correctamente el rostro del paciente.
          </p>
          <p data-id="element-265" data-mp="204kppevl9as">Y ahí es donde la mayoría de los errores empiezan.</p>
          <p data-id="element-266" data-mp="14bbq400xukrn">No por falta de conocimiento. Sino por falta de un proceso claro.</p>
        </div>

        <div className="mt-8 rounded-3xl border-l-4 border-gold-500 bg-white p-5 shadow-card sm:p-6" data-id="element-267" data-mp="199wtg8bhlkkb">
          <p className="font-display text-[19px] font-semibold leading-snug text-navy-900 sm:text-2xl" data-id="element-268" data-mp="vane1av3uuhe">
            El verdadero problema no es la cefalometría.
          </p>
          <p className="mt-2 text-[15px] leading-relaxed text-navy-600 sm:text-[17px]" data-id="element-269" data-mp="10bbeso94ypot">
            Es no saber cómo convertir toda esa información en una decisión clínica segura.
          </p>
        </div>

        <div className="mt-8" data-id="element-270" data-mp="1e99eqompmjks">
          <p className="text-[14px] font-bold uppercase tracking-[0.08em] text-navy-400" data-id="element-271" data-mp="1ea1bw3vygpd6">
            Probablemente esto te ha pasado más de una vez…
          </p>
          <ul className="mt-4 space-y-0 border-l border-dashed border-navy-200 pl-5" data-id="element-272" data-mp="1j5zwrhi2rp8u">
            {['Analizas el caso.', 'Revisas la cefalometría.', 'Vuelves a observar las fotografías.', 'Comparas medidas.', 'Repites el análisis.'].map(step => <li key={step} className="relative py-2 text-[15px] font-medium text-navy-800" data-id="element-273" data-mp="2gl9i4gtlz79j">
                <span className="absolute -left-[1.55rem] top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-gold-500" data-id="element-274" data-mp="2bln4w7ds5r0q" />
                {step}
              </li>)}
          </ul>
          <p className="mt-4 text-[15px] leading-relaxed text-navy-600 sm:text-[17px]" data-id="element-275" data-mp="22m9sb5ud0mbs">
            Y aun así… sientes que algo no termina de encajar. Entonces aparece la duda.
          </p>
        </div>

        <div className="mt-6 space-y-2.5" data-id="element-276" data-mp="1svf621h45mqc">
          {['¿Estoy viendo todo lo que debería?', '¿Realmente esta es la mejor opción para este paciente?', '¿Estoy dejando pasar una señal importante?'].map(question => <p key={question} className="rounded-2xl bg-navy-800 px-4 py-3 text-[14.5px] font-semibold italic leading-snug text-white sm:text-base" data-id="element-277" data-mp="1izljrqdleevd">
              {question}
            </p>)}
        </div>

        <div className="mt-7 space-y-3 text-[15px] leading-relaxed text-navy-600 sm:text-[17px]" data-id="element-278" data-mp="3ujt3baih0ex5">
          <p className="font-semibold text-navy-900" data-id="element-279" data-mp="3g4evsf7kjuw">Y cuando existe incertidumbre…</p>
          <p data-id="element-280" data-mp="8cuuken3pdfs">
            También aparecen tratamientos más largos, retratamientos y resultados estéticos por
            debajo de lo esperado.
          </p>
          <p data-id="element-281" data-mp="3bumi9gu7fb86">
            Y esa incómoda sensación de que quizá pudiste haber tomado una mejor decisión desde el
            principio.
          </p>
        </div>

        <TransformCta headline="Cambia la duda por un proceso clínico que puedes repetir en cada paciente." label="Quiero diagnosticar con seguridad" location="problema" data-id="element-282" data-mp="3gs4qf50edmf4" />
      </div>
    </section>;
}